import Image from 'next/image';

import { Box } from '@chakra-ui/react';

import {
  type BackToSchool2026Phase2Variant,
  BTS_2026_P2_VARIANTS,
} from '~/features/promotions/constants/back-to-school-2026-phase-2-sale';

/**
 * Matches `ATF_PROMO_DECORATION_SIZES` in `experience-atf-hero-card.tsx`: the promo shell is 260px
 * below Chakra's `xl` breakpoint and 300px at or above it.
 */
const ATF_PROMO_DECORATION_SIZES = '(max-width: 1279px) 260px, 300px';

/**
 * Back to School 2026 phase 2 ATF background — the ruled-notebook lines and diagonal pencil art on
 * a transparent PNG, layered over the card's purple gradient (Figma 1944:1380 G1, 1944:1402 G2).
 * Lives in its own module because `experience-atf-hero-card.tsx` is already past the file-size
 * budget for this repo.
 */
export function Bts2026Phase2AtfBgDecoration({
  imagePriority,
  variant,
}: {
  imagePriority: boolean;
  variant: BackToSchool2026Phase2Variant;
}) {
  const config = BTS_2026_P2_VARIANTS[variant];

  return (
    <Box bottom={0} left={0} position='absolute' right={0} top={0}>
      <Image
        alt=''
        loading='eager'
        priority={imagePriority}
        sizes={ATF_PROMO_DECORATION_SIZES}
        src={config.experienceAtfBg}
        style={{
          objectFit: config.experienceAtfObjectFit,
          objectPosition: config.experienceAtfObjectPosition,
        }}
        fill
      />
    </Box>
  );
}
